export const normalizar = (s) =>
  (s == null ? "" : String(s))
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const tokens = (q) => normalizar(q).split(" ").filter(Boolean);

export const coincideTodos = (textoNorm, toks) => toks.every((t) => textoNorm.includes(t));
